import { render, staticRenderFns } from "./RunnitsApp.vue?vue&type=template&id=479b9779&scoped=true"
import script from "./RunnitsApp.vue?vue&type=script&lang=ts"
export * from "./RunnitsApp.vue?vue&type=script&lang=ts"
import style0 from "./RunnitsApp.vue?vue&type=style&index=0&id=479b9779&prod&lang=scss"
import style1 from "./RunnitsApp.vue?vue&type=style&index=1&id=479b9779&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479b9779",
  null
  
)

export default component.exports